// extracted by mini-css-extract-plugin
export default {"google_review":"googleReview_google_review__VK7Pd","review_part":"googleReview_review_part__hiG6X","google_part":"googleReview_google_part__X2bHz"};